import { urlWorks } from "./urls"

export const messagesEditWork = { 
    type : 'editWork',
    url : urlWorks,
    messageTextsOK : {
        messageTitle : 'Obra editada con éxito',
        buttonLeft : '',
        buttonRight: 'Continuar'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : '',
        buttonRight: 'Volver a obras'
    }
}